
export class SclSearchClientConstantService {
  static operator = {
    equals: 'eq',
    notEquals: 'neq',
    contains: 'contains'
  };
}

